import CardDropdown from 'components/common/CardDropdown';
import SingleImageUpload from 'components/common/SingleImageUpload';
import SoftBadge from 'components/common/SoftBadge';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AutocompleteTag from 'components/input/AutocompleteTag';
import LoadingWrapper from 'components/loading/LoadingWrapper';
import ConfirmationModal from 'components/modal/ConfirmationModal';
import AppContext, { AuthContext } from 'context/Context';
import useDelete from 'hooks/useDelete';
import usePost from 'hooks/usePost';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { Button, Col, Dropdown, Form, Modal, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { queryReducer } from 'reducers/queryReducer';
import { getBlogCategory } from 'services/content';
import serviceUrl from 'services/serviceUrlList';
import { createBlogCategory, updateBlogCategory } from '../api';

const BlogCategory = props => {
  const { newClickCount } = props;
  const { user } = useContext(AuthContext);
  const {
    config: { isDark }
  } = useContext(AppContext);
  const [queryObj, setQueryObj] = useState({
    limit: 10,
    offset: 0
  });
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    is_active: true,
    name: '',
    description: '',
    display_name: '',
    image: '',
    image_alt_text: '',
    site: 1
  });
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [defaultImg, setDefaultImg] = useState(undefined);
  const {
    register,
    setValue,
    reset,
    handleSubmit,
    clearErrors,
    formState: { errors }
  } = useForm();
  const [selectedTags, setSelectedTags] = useState([]);

  const openCreateModal = () => setIsCreateModalOpen(true);
  const closeCreateModal = () => {
    setIsCreateModalOpen(false);
    clearFormData();
    setSelectedRowId(null);
  };

  const {
    data,
    isLoading: tableLoading,
    refetch
  } = useQuery(['getBlogCategory', queryObj], () => getBlogCategory(queryObj), {
    keepPreviousData: false,
    staleTime: Infinity
  });
  const [deleteResponse, deleteRequest] = useDelete({
    url: serviceUrl.content.blogCategory.detail + selectedRowId
  });

  useEffect(() => {
    if (newClickCount === 0) return;
    openCreateModal(true);
  }, [newClickCount]);

  const onSubmit = () => {
    if (selectedRowId === null) {
      // Post Request
      handleCreateBlogCategory();
    } else {
      // Update Request !
      handleUpdateBlogCategory(selectedRowId);
    }
  };

  const handleCreateBlogCategory = async () => {
    formData.tag_names = selectedTags.join(',');
    formData.created_by = user.id;
    let fData = new FormData();
    for (const key in formData) {
      fData.append(key, formData[key]);
    }
    const response = await createBlogCategory(fData);
    if (response.status === 201) {
      closeCreateModal();
      refetch();
      toast.success(`Category created`, {
        theme: 'colored'
      });
    } else {
      if (response.data.name) {
        toast.error(`Name field must be unique!`, {
          theme: 'colored'
        });
      }
    }
  };

  const handleUpdateBlogCategory = async id => {
    if (selectedTags.length > 0) {
      formData.tag_names = selectedTags.join(',');
    }
    formData.updated_by = user.id;
    let fData = new FormData();
    if (
      formData.image === '' ||
      typeof formData.image === 'string' ||
      !formData.image
    ) {
      delete formData.image;
    }
    for (const key in formData) {
      fData.append(key, formData[key]);
    }
    const response = await updateBlogCategory(fData, id);
    if (response.status === 200) {
      closeCreateModal();
      refetch();
      toast.success(`Category updated`, {
        theme: 'colored'
      });
    } else {
      if (response.data.name) {
        toast.error(`Name field must be unique!`, {
          theme: 'colored'
        });
      }
    }
  };

  const handleChange = ({ target }) => {
    let name = target.name;
    let value = target.value;
    setFormData({ ...formData, [name]: value });
  };

  const handleEditItem = dt => {
    setSelectedRowId(dt.id);
    setSelectedTags(dt.tags.map(dt => dt.name));
    setDefaultImg({
      path: dt.image,
      alt: dt.image_alt_text
    });
    const newDt = { ...dt };
    delete newDt.tags;
    setFormData(newDt);
    setValue('name', dt.name);
    setValue('display_name', dt.display_name);
    openCreateModal(true);
  };
  const handleCloseDeleteModal = state => {
    setShowConfirm(state);
  };
  const handleDeleteItem = id => {
    setSelectedRowId(id);
    setShowConfirm(true);
  };
  useEffect(() => {
    // delete sonrası çalışması beklenen useEffect
    if (deleteResponse.data === null && deleteResponse.error === null) return;
    setShowConfirm(false);
    closeCreateModal();
    refetch();
    toast.success(`Category deleted`, {
      theme: 'colored'
    });
    setSelectedRowId(null);
  }, [deleteResponse]);

  const handleModalDeleteButton = () => {
    if (selectedRowId === null) {
      closeCreateModal();
    } else {
      handleDeleteItem(selectedRowId);
    }
  };

  const handleImgFile = image => {
    if (!image) image = '';
    setFormData({ ...formData, image: image });
  };

  const handleAltText = alt => {
    setFormData({ ...formData, image_alt_text: alt });
  };

  const handleRefetchAll = () => {
    refetch();
  };

  const clearFormData = () => {
    setFormData({
      is_active: true,
      name: '',
      description: '',
      display_name: '',
      image: '',
      image_alt_text: '',
      tagList: [],
      site: 1
    });
    setDefaultImg(undefined);
    clearErrors();
    setSelectedTags([]);
    reset();
  };

  // ss pagination start
  const [{ pageIndex, pageSize, totalCount }, dispatch] = useReducer(
    queryReducer,
    { pageIndex: 0, pageSize: 10, totalCount: data?.data.count }
  );
  useEffect(() => {
    setQueryObj({
      ...queryObj,
      limit: pageSize,
      offset: pageSize * pageIndex
    });
  }, [pageSize, pageIndex, totalCount]);

  useEffect(() => {
    if (!data?.data.count) return;
    dispatch({
      type: 'TOTAL_COUNT_CHANGED',
      payload: data?.data.count
    });
  }, [data?.data.count]);
  // ss pagination end

  const columns = [
    {
      accessor: 'name',
      Header: 'Name',
      headerProps: { className: 'pe-1 text-start' },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { name } = rowData.row.original;
        return (
          <a href="#" onClick={() => handleEditItem(rowData.row.original)}>
            {name}
          </a>
        );
      }
    },
    {
      accessor: 'description',
      Header: 'Description',
      headerProps: { className: 'pe-1 text-start' },
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'parent.name',
      Header: 'Parent',
      headerProps: { className: 'pe-1 text-start' },
      cellProps: {
        className: 'py-2'
      },
      Cell: dt => {
        const parentName = dt.row.original.parent?.label;
        return <span>{parentName}</span>;
      }
    },
    {
      accessor: 'is_active',
      Header: 'Status',
      cellProps: { className: 'text-center' },
      Cell: dt => {
        const { is_active } = dt.row.original;
        if (is_active) {
          return (
            <SoftBadge pill bg="success" className="d-block">
              Active
            </SoftBadge>
          );
        }
        return (
          <SoftBadge pill bg="danger" className="d-block">
            Passive
          </SoftBadge>
        );
      }
    },
    {
      accessor: 'none',
      Header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      Cell: dt => {
        const { id } = dt.row.original;
        return (
          <CardDropdown iconClassName="fs--1">
            <div className="py-2">
              <Dropdown.Item onClick={() => handleEditItem(dt.row.original)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleDeleteItem(id)}>
                Delete
              </Dropdown.Item>
            </div>
          </CardDropdown>
        );
      }
    }
  ];

  return (
    <div className="p-2">
      <LoadingWrapper loading={tableLoading}>
        <AdvanceTableWrapper
          columns={columns}
          data={data?.data.results || []}
          selection
          sortable
          pagination
          perPage={queryObj.limit}
          queryPageIndex={pageIndex}
          totalCount={totalCount}
          dispatch={dispatch}
        >
          <TableHeader
            table
            handleRefetchAll={handleRefetchAll}
            setQueryObj={setQueryObj}
          />
          <div className="my-3">
            <AdvanceTable
              table
              headerClassName="bg-200 text-900 text-nowrap align-middle text-center"
              tableProps={{
                size: 'sm',
                striped: true,
                className: 'fs--1 mb-0 align-middle'
              }}
            />
          </div>
          <AdvanceTablePagination table />
        </AdvanceTableWrapper>
      </LoadingWrapper>

      <Modal
        size="lg"
        show={isCreateModalOpen}
        onHide={closeCreateModal}
        contentClassName="border"
      >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header
            closeButton
            closeVariant={isDark ? 'white' : undefined}
            className="bg-light px-card border-bottom-0"
          >
            <Modal.Title as="h5">
              {selectedRowId === null ? 'Add' : 'Update'} Category
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-card">
            <Form.Group
              className="mb-3"
              controlId="is_active"
              style={{
                width: 120,
                position: 'absolute',
                right: 20,
                top: 10
              }}
            >
              <Form.Select
                size="sm"
                className="mb-3"
                name="is_active"
                required
                value={formData.is_active}
                onChange={handleChange}
              >
                <option value={Boolean(true)}>Active</option>
                <option value={Boolean(false)}>Passive</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label className="fs-0">Name</Form.Label>
              <Form.Control
                {...register('name', {
                  required: 'This field cannot be empty!'
                })}
                isInvalid={errors.name}
                type="text"
                name="name"
                placeholder="Category name"
                value={formData.name}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.name?.message}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="description">
              <Form.Label className="fs-0">Description</Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Category description"
                rows={3}
                name="description"
                value={formData.description}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="display_name">
              <Form.Label className="fs-0">Display Name</Form.Label>
              <Form.Control
                {...register('display_name', {
                  required: 'This field cannot be empty!'
                })}
                isInvalid={errors.display_name}
                type="text"
                name="display_name"
                placeholder="Display name"
                value={formData.display_name}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.display_name?.message}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="tag">
              <Form.Label>Tags</Form.Label>
              <AutocompleteTag
                placeholder="Select your tags"
                selected={selectedTags}
                onChange={setSelectedTags}
                service="content"
              />
            </Form.Group>
            <SingleImageUpload
              file={handleImgFile}
              altText={handleAltText}
              defaultImg={defaultImg}
            />
          </Modal.Body>
          <Modal.Footer className="bg-light px-card border-top-0">
            <Button
              variant="danger"
              className="px-3 mx-2"
              onClick={handleModalDeleteButton}
            >
              {selectedRowId === null ? 'Cancel' : 'Delete'}
            </Button>
            <Button variant="primary" type="submit" className="px-5 mx-0">
              {selectedRowId === null ? 'Save' : 'Update'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <ConfirmationModal
        showConfirm={showConfirm}
        setShowConfirm={handleCloseDeleteModal}
        title="Delete Category"
        description="Are you sure the category you selected will be deleted?"
        request={deleteRequest}
      />
    </div>
  );
};

BlogCategory.propTypes = {
  newClickCount: PropTypes.number
};

export default BlogCategory;

const TableHeader = props => {
  const { selectedRowIds, ids, handleRefetchAll, setQueryObj } = props;
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmText, setConfirmText] = useState({
    title: '',
    description: '',
    type: ''
  });
  const [action, setAction] = useState(undefined);
  const [payload, setPayload] = useState(undefined);
  const [postResponse, postRequest] = usePost({
    url: serviceUrl.content.bulk_actions,
    payload: payload
  });

  useEffect(() => {
    // Submit sonrası çalışması beklenen useEffect
    if (!postResponse.data && !postResponse.error) return;
    toast.success(`Bulk action completed`, {
      theme: 'colored'
    });
    handleRefetchAll();
  }, [postResponse]);

  const handleSetAction = e => {
    setAction(e.target.value);
  };

  const submitBulkAction = () => {
    if (action === undefined) {
      toast.error(`Select action for bulk action!`, {
        theme: 'colored'
      });
      return;
    }
    const payload_ = {
      table_name: 'ProductCategory',
      id_list: ids
    };
    if (action === 'delete') {
      payload_.is_deleted = true;
      setConfirmText({
        title: 'Bulk Delete action',
        description: 'Are you sure? Selected categories will be deleted!',
        type: 'delete'
      });
    } else if (action === 'passive') {
      payload_.is_active = false;
      setConfirmText({
        title: 'Bulk status action',
        description: 'Are you sure? Selected categories will be archieved!',
        type: 'update'
      });
    } else if (action === 'active') {
      payload_.is_active = true;
      setConfirmText({
        title: 'Bulk status action',
        description: 'Are you sure? Selected categories will be activated!',
        type: 'update'
      });
    }
    setShowConfirm(true);
    setPayload({ ...payload_ });
  };

  const handleBlogCategorySearch = value => {
    setQueryObj(prev => ({
      ...prev,
      search_value: value
    }));
  };

  return (
    <Row className="">
      <Col xs={6} className="d-flex align-items-center pe-0">
        <AdvanceTableSearchBox
          table
          size="sm"
          placeholder="Filter categories by the name or description"
          setGlobalFilter={handleBlogCategorySearch}
        />
      </Col>
      <Col xs={4} sm="auto" className="ms-auto text-end ps-0">
        {Object.keys(selectedRowIds).length > 0 ? (
          <div className="d-flex">
            <Form.Select
              value={action}
              onChange={handleSetAction}
              size="sm"
              aria-label="Bulk actions"
            >
              <option hidden>Bulk Actions</option>
              <option value="delete">Delete</option>
              <option value="passive">Passive</option>
              <option value="active">Active</option>
            </Form.Select>
            <Button
              type="button"
              variant="falcon-default"
              size="sm"
              className="ms-2"
              onClick={submitBulkAction}
            >
              Apply
            </Button>
          </div>
        ) : null}
      </Col>

      <ConfirmationModal
        showConfirm={showConfirm}
        setShowConfirm={setShowConfirm}
        title={confirmText.title}
        description={confirmText.description}
        request={postRequest}
        type={confirmText.type}
      />
    </Row>
  );
};

TableHeader.propTypes = {
  selectedRowIds: PropTypes.object,
  ids: PropTypes.array,
  setQueryObj: PropTypes.func,
  handleRefetchAll: PropTypes.func
};
